<template>
  <v-container fluid full-height grid-list-md>
    <v-layout row wrap>
      <v-flex xs6>
        <div class="text-xs-left">
          <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
        </div>
      </v-flex>
      <v-flex xs6>
        <div class="text-xs-right">
          <v-btn color="primary" @click="onRegister">
            New Category
            <v-icon right>add_circle</v-icon>
          </v-btn>
          <v-btn color="primary" @click="openDialog=true">Import Category</v-btn>
        </div>
      </v-flex>
      <v-flex xs12>
        <v-card>
          <v-layout row wrap class="pa-3">
            <v-flex sm3>
              <v-text-field
                name="name"
                label="Category Name"
                type="text"
                v-model="queryParams.name"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-text-field
                name="code"
                label="Category Code"
                type="text"
                v-model="queryParams.code"
              ></v-text-field>
            </v-flex>
            <v-flex sm3>
              <v-select
                :items="statusList"
                label="Status"
                v-model="queryParams.status"
                item-text="label"
                item-value="value"
              ></v-select>
            </v-flex>
            <v-flex sm3>
              <v-btn outline color="primary" @click="onSearch">
                Search
                <v-icon right>search</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
      <v-flex d-flex xs12>
        <v-card>
          <v-card-text class="font-weight-bold">
            <div>
              <v-btn
                :loading="exportAllButtonLoading"
                color="success"
                @click="getExportAllCategory()"
              >EXPORT ALL</v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
      <v-flex xs12 class="mt-1">
        <v-card>
          <v-data-table
            :headers="headers"
            :items="categoryList"
            class="elevation-1"
            :loading="showListLoading"
            :total-items="totalRows"
            :rows-per-page-items="rowsPerPageItems"
            :pagination.sync="pagination"
            :must-sort="true"
          >
            <template slot="items" slot-scope="props">
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.code }}</td>
              <td>{{ props.item.description }}</td>
              <td>{{ props.item.updatedDateInMilliSeconds | format-ms-date-time }}</td>
              <td>{{ props.item.updatedBy }}</td>
              <td>
                <v-icon v-if="props.item.status=='ACTIVE'" medium color="green">check_circle</v-icon>
                <v-icon v-else medium color="red">cancel</v-icon>
              </td>
              <td>
                <v-btn flat icon color="blue lighten-2" @click="onEdit(props.item)">
                  <v-icon>edit</v-icon>
                </v-btn>
              </td>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- dialog -->
    <categoryExcel :isOpen="openDialog" v-on:change="dialogClose()"></categoryExcel>
    <!-- print section -->
  </v-container>
</template>

<script>
import { categoryService } from "../../services/category-service";
import categoryExcel from "../../components/category/CategoryExcel";
import { commonService } from "../../services/common-service";

export default {
  name: "CategoryList",

  components: { categoryExcel },
  data: () => ({
    showListLoading: false,
    openDialog: false,
    breadcrumbs: [
      {
        text: "General",
        disabled: true
      },
      {
        text: "Category",
        disabled: true
      }
    ],
    headers: [
      { text: "Name", align: "left", value: "name" },
      { text: "Code", value: "code" },
      { text: "Description", value: "description" },
      { text: "Updated Date", value: "updatedDate" },
      { text: "Updated By", value: "updatedBy" },
      { text: "Status", value: "status", sortable: false },
      { text: "Action", value: "name", sortable: false }
    ],
    rowsPerPageItems: [25, 50, 100],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 50,
      sortBy: "name",
      totalItems: 0
    },
    categoryList: [],
    totalRows: 0,
    statusList: [
      { label: "All", value: "" },
      { label: "Active", value: "ACTIVE" },
      { label: "Inactive", value: "INACTIVE" }
    ],
    queryParams: {
      name: "",
      code: "",
      status: "ACTIVE"
    },
    clonequeryParams: new Object(),
    exportAllButtonLoading: false
  }),
  watch: {
    pagination: {
      handler() {
        this.getCategoryList();
      },
      deep: true
    }
  },
  created() {
    //for deep linking
    if (this.$route.query.name) {
      this.queryParams.name = this.$route.query.name;
    }
    if (this.$route.query.code) {
      this.queryParams.code = this.$route.query.code;
    }
    if (this.$route.query.status) {
      this.queryParams.status = this.$route.query.status;
    }
    if (this.$route.query.page) {
      this.pagination.page = this.$route.query.page;
    }
    if (this.$route.query.size) {
      this.pagination.size = this.$route.query.size;
    }
    this.clonequeryParams = Object.assign({}, this.queryParams);
  },

  methods: {
    onSearch() {
      this.queryParams.page = this.pagination.page;
      this.queryParams.size = this.pagination.rowsPerPage;
      this.$router.replace({ name: "categories", query: this.queryParams });
      this.getCategoryList();
      this.clonequeryParams = Object.assign({}, this.queryParams);
    },
    getCategoryList() {
      this.showListLoading = true;
      let order = this.pagination.descending ? "desc" : "asc";
      categoryService
        .getCategoryList(
          this.queryParams,
          this.pagination.page,
          this.pagination.rowsPerPage,
          this.pagination.sortBy + "," + order
        )
        .then(res => {
          if (res.data) {
            this.categoryList = res.data.categoryList;
            this.totalRows = res.data.totalElements;
          }
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.showListLoading = false;
        });
    },
    onRegister() {
      this.$router.push("/category/new");
    },
    onEdit(category) {
      // go to details page
      this.$router.push("/category/" + category.id);
    },
    dialogClose() {
      this.openDialog = false;
      this.getCategoryList();
    },
    getExportAllCategory() {
      this.exportAllButtonLoading = true;
      categoryService
        .exportAllCategory(this.clonequeryParams)
        .then(res => {
          commonService.downloadE(res);
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => {
          this.exportAllButtonLoading = false;
        });
    }
  }
};
</script>